import { render, staticRenderFns } from "./PadSaleSelector.vue?vue&type=template&id=64aa2e4e&"
import script from "./PadSaleSelector.vue?vue&type=script&lang=js&"
export * from "./PadSaleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports